import event from 'event'
import cookie from 'cookie'
import { query } from 'qs'
import store from 'store2'
import sessionStorage from 'sessionStorage'
import $ from '$'
import ua from 'ua'
import navigationUtil from 'navigationUtil'

let channel = query && (query.channel || query.utm_source)
if (channel && (!cookie.get('channel') || cookie.get('channel') !== channel)) {
  cookie.set('channel', channel, 1 * 24)
}

if (ua.isWechat() && query.pner) {
  cookie.set('pner', query.pner, 24, '.piaoniu.com', '/')
}

var requestCaches = {}
var dataCaches = {}
fetch.BASE_HOST = ''

function serverRequest(method, url, data, headers, success, errorHandler) {
  // var Cat
  // if (!process.browser) {
  //   // 绕过webpack依赖检查
  //   Cat = require('pn-cat-client')
  // }
  var hosts = require('hosts')
  var axios = require('axios')
  // require('zone.js')
  var _method = method.toLowerCase()
  var _data = _method == 'get' ? { params: data, headers: headers } : data
  var h = fetch.BASE_HOST || hosts.requestIP()
  axios.defaults.timeout = 30000 // 部分接口过慢ssr请求会超时，这里先拉长吧 5000 -> 30000

  if (!process.env.APP_ENV) {
    if (process.env.USE_PRODUCTION_API == 'true') {
      h = hosts.PRODUCTION
    } else {
      h = hosts.BETA
      // h = 'localhost:4000'
    }
  }
  headers.host = h

  console.log(method.toUpperCase() + ': http://' + h + url, _data)

  let Cat = Zone.current.get('Cat')
  let originReq = Zone.current.get('req')
  let logger = Zone.current.get('logger')
  let transaction = null
  if (Cat) {
    transaction = Cat.newTransaction('ApiCall', url)
  }
  let startTime = +new Date()
  axios[_method]('http://' + h + url, _data, { headers: headers })
    .then((resp) => {
      let data = resp.data
      success(data)
      const loggerMessage = 'backEndApiRequestTime'
      logger.log(loggerMessage, {
        requestId: originReq.requestId,
        url: originReq.url,
        referrer: originReq.headers['referer'],
        requestUrl: 'http://' + h + url,
        ms: +new Date() - startTime
      })
      if (transaction) {
        logger
        process.nextTick(() => {
          transaction.setStatus(Cat.STATUS.SUCCESS)
          transaction.complete()
        })
      }
      return data
    })
    .catch((err) => {
      if (errorHandler) {
        const message = url + ' ' + err.message
        err.message = message
        console.log('REQ: ERR', message)
        errorHandler(err)
      }
      if (transaction) {
        process.nextTick(() => {
          transaction.setStatus(Cat.STATUS.FAIL)
          transaction.complete()
        })
      }
    })
}

function clientRequest(method, url, data, headers, success, error) {
  $.ajax({
    type: method,
    url: url,
    data: data,
    contentType: headers.ContentType || 'application/json',
    success: success,
    error: error
  })
}

function fetch(params) {
  params = params || {}
  var method = params.method || 'GET'
  var data = params.data
  var headers = params.headers || {}

  if (!method.match(/^get$/i)) {
    data = JSON.stringify(params.data)
  }

  var currentReq = null
  var url = params.url
  var key = params.key

  if (params.noRepeat) {
    if (requestCaches[url]) {
      return requestCaches[url]
    }
  }

  var req = new Promise(function (resolve, reject) {
    if (params.session) {
      if (sessionStorage.get(key)) {
        return resolve(sessionStorage.get(key))
      }
    }

    if (params.cache) {
      var cache = dataCaches[key] || store.get(key)
      if (cache) {
        return resolve(cache)
      }
    }

    (console.debug || console.log).call(console, method.toUpperCase() + ':', url)

    for (var k in data) {
      if (data[k] === undefined) {
        delete data[k]
      }
    }

    var request = process.browser ? clientRequest : serverRequest
    currentReq = request(method, '/api' + url, data, headers, function (data) {
      if (process.browser) {
        let $loading = $('.loading')
        $loading.each(function (i, el) {
          let $el = $(el)
          if (!$el.attr('data-id')) {
            $el.hide()
          }
        })
      }
      req.emit('success', data)
      req.emit('complete')

      if (params.cache) {
        dataCaches[key] = data
        store.set(key, data)
      }

      if (params.session) {
        sessionStorage.set(key, data)
      }
      resolve(data)
    }, function (xhr, err) {
      if (process.browser) {
        var errorText = ''
        if (xhr.status === 429) {
          try {
            const errMsg = JSON.parse(xhr.response || xhr.responseText)
            reject(errMsg)
          } catch (e) {
            console.log('e', e);
          }
          return
        }
        if (xhr.status === 502 || xhr.status === 404) {
          errorText = '服务器开小差了'
        } else if (xhr.status === 401) {
          errorText = xhr.response || xhr.responseText || '系统错误'
          cookie.remove('pnid', '.piaoniu.com')
          if (ua.isPiaoniuMiniProgram() || ua.isPiaoniuAliMiniProgram()) {
            navigationUtil.toBindPhone()
          } else {
            let redir = location.href
            location.href = `/user/login.html?redir=${encodeURIComponent(redir)}`
          }
        } else {
          errorText = xhr.response || xhr.responseText || '系统错误'
        }
        req.emit('complete')
        if (err === 'abort') {
          req.emit('abort')
          return
        } else {
          req.emit('error', errorText, xhr)
        }
        reject(errorText)
      } else {
        if (params.failable) {
          resolve()
        } else {
          const util = require('util')
          const err = arguments[0]
          err.message = [err.message, "url:" + url, "data:" + util.inspect(data)].join("\n")
          reject(err)
        }
      }
    })
  })

  if (process.browser) {
    requestCaches[url] = req
  }

  req.cancel = () => {
    console.debug('cancel', url)
    currentReq && currentReq.abort()
  }

  event.mixin(req)
  return req
}

export default fetch

export function loginOut(successCb) {
  $.ajax({
    type: 'GET',
    url: '/api/v1/user/logout',
    success: function (res) {
      successCb(res)
    }
  })
}



// WEBPACK FOOTER //
// ./src/mods/fetch.js